/**
 *
 * Global Nav (JS)
 *
 * @author Space-Time Inc.
 *
 */


document.addEventListener('DOMContentLoaded', function () {

	const timeOut = 200;
	var enterEventFirst = 0;
	var leaveEvent = 0;

	var mis = document.querySelectorAll('.hover-and-touch > ul > li');
	var items = [];


	for (var i = 0; i < mis.length; i += 1) {
		items.push(mis[i]);
		setEventListenerforFirstLevel(mis[i]);
	}

	function setEventListenerforFirstLevel(item) {

		var lab = item.firstElementChild;
		if (lab == null) return;
		if (lab.length === 0) return;

		item.addEventListener('mouseleave', function (e) {
			leaveEvent = setTimeout(function () {
				clearVisibleState(items);
			}, timeOut);
		});

		item.addEventListener('mouseenter', function (e) {
			clearTimeout(leaveEvent);
		});

		lab.addEventListener('mouseenter', function (e) {
			enterEventFirst = setTimeout(function () {
				e.preventDefault();
				clearVisibleState(items);
				item.classList.add('visible');
			}, timeOut);

		});

		lab.addEventListener('mouseleave', function (e) {
			clearTimeout(enterEventFirst);
		});

		lab.addEventListener('touchstart', function (e) {
			var hrefcheck = lab.href;
			if (hrefcheck == undefined || hrefcheck == '#') {
				e.preventDefault();
				var visible = item.classList.contains('visible');
				clearVisibleState(items);
				if (!visible) item.classList.add('visible');
			}
		});
	}

	function clearVisibleState(objs) {
		for (var i = 0; i < objs.length; i += 1) {
			objs[i].classList.remove('visible');
		}
	}

});
